import { useStaticQuery, graphql } from "gatsby"

export const useChapterNavImageData = () => {
	const data = useStaticQuery(graphql`
		{
			chapter1: file(relativePath: { eq: "nav/nav_ages.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter2: file(relativePath: { eq: "nav/nav_legacy.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter3: file(relativePath: { eq: "nav/nav_future.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter4: file(relativePath: { eq: "nav/nav_virtual.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter5: file(relativePath: { eq: "nav/nav_celebration.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter6: file(relativePath: { eq: "nav/nav_terriers.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter7: file(relativePath: { eq: "nav/nav_home.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter8: file(relativePath: { eq: "nav/nav_racism.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter9: file(relativePath: { eq: "nav/nav_testing.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter10: file(relativePath: { eq: "nav/nav_frontlines.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter11: file(relativePath: { eq: "nav/nav_learn.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter12: file(relativePath: { eq: "nav/nav_unrest.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter13: file(relativePath: { eq: "nav/nav_ghosts.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter14: file(relativePath: { eq: "nav/nav_spotlight.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter15: file(relativePath: { eq: "nav/nav_impact.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter16: file(relativePath: { eq: "nav/nav_fighting.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter17: file(relativePath: { eq: "nav/nav_fuck.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter18: file(relativePath: { eq: "nav/nav_diversity.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter19: file(relativePath: { eq: "nav/nav_normal.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
			chapter20: file(relativePath: { eq: "nav/nav_end.jpg" }) {
				id
				childImageSharp {
					fluid(maxWidth: 2000, quality: 75) {
						...GatsbyImageSharpFluid_withWebp
					}
				}
			}
		}
	`)
	return data
}